import script from "./ResultBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultBlock.vue?vue&type=script&setup=true&lang=js"

import "./ResultBlock.vue?vue&type=style&index=0&id=502f48a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502f48a3"]])

export default __exports__